module.exports = __webpack_public_path__ + "static/header-logo-dec267723c5dde1f248e619bd2d11c90.png";